var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ChalkyTrainerViewModalMatchConfig',{staticClass:"view-modal-global-play",attrs:{"initialConfig":_vm.initialConfig},on:{"submit":_vm.Handle_OnSubmit},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }